import { BRAND, TAGLINE, PACKAGE_NAME } from "./site";

export const origin = () => window.location.origin;

export const webPageLd = ({ title, description, path }) => ({
  "@context": "https://schema.org",
  "@type": "WebPage",
  name: title,
  description,
  url: origin() + path,
  isPartOf: { "@type": "WebSite", name: BRAND, url: origin() + "/" },
});

export const breadcrumbLd = (items, homeName = "Home", lp = (p) => p) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [{ name: homeName, path: "/" }, ...items].map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: origin() + lp(it.path),
  })),
});

export const faqLd = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
});

export const softwareLd = (apk, lp = (p) => p) => {
  const ld = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: BRAND,
    description: `${BRAND} — ${TAGLINE}. Official Android APK.`,
    applicationCategory: "FinanceApplication",
    operatingSystem: "Android",
    url: origin() + lp("/download"),
    identifier: PACKAGE_NAME,
    offers: { "@type": "Offer", price: "0", priceCurrency: "INR" },
  };
  if (apk) {
    ld.softwareVersion = apk.version_name;
    ld.fileSize = `${Math.round(apk.size / 1024)}KB`;
    ld.datePublished = (apk.release_date || apk.created_at)?.slice(0, 10);
    ld.downloadUrl = origin() + apk.download_url;
    ld.operatingSystem = `Android ${apk.min_android}+`;
  }
  return ld;
};
